export const BASE_URL = 'http://classcar.kr';

export const INQUIRE = '/api/v1/inquire';
